import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { FileSpreadsheet, ArrowRight, Wrench } from "lucide-react";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

const TOOLS = [
  {
    id: "mutabakat",
    title: "Mutabakat Form Oluşturucu",
    description:
      "Toplu PDF dosyalarınızı yükleyin, mutabakat verilerini otomatik çıkarın ve ZIP olarak indirin.",
    icon: FileSpreadsheet,
    path: "/mutabakat",
    accent: "blue",
    active: true,
  },
];

const DashboardPage = () => {
  const user = useSelector((state) => state.auth.user);

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14">
        {/* Hero / Welcome */}
        <section className="mb-10 md:mb-14" data-testid="welcome-section">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white border border-slate-200 text-xs font-medium uppercase tracking-widest text-slate-600 mb-4">
            <Wrench className="w-3.5 h-3.5" />
            Firma Araçları
          </div>
          <h1
            className="font-heading text-3xl md:text-5xl font-bold tracking-tight text-slate-900"
            data-testid="welcome-title"
          >
            Hoş geldiniz, {user?.displayName || user?.username}.
          </h1>
          <p className="text-base text-slate-500 mt-3 max-w-2xl">
            ALTINGROSS iç araçlarına buradan erişebilirsiniz. Aşağıdaki kartlardan
            ihtiyacınız olan aracı seçin.
          </p>
        </section>

        {/* Tools Grid */}
        <section
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
          data-testid="tools-grid"
        >
          {TOOLS.map((tool) => {
            const Icon = tool.icon;
            return (
              <Card
                key={tool.id}
                className="group relative overflow-hidden border-slate-200 bg-white hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200"
                data-testid={`tool-card-${tool.id}`}
              >
                <CardContent className="p-6 md:p-7 flex flex-col h-full min-h-[260px]">
                  <div className="flex items-start justify-between mb-6">
                    <div className="w-12 h-12 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center group-hover:bg-blue-600 group-hover:text-white transition-colors">
                      <Icon className="w-6 h-6" />
                    </div>
                    <span className="text-[10px] font-semibold uppercase tracking-widest text-emerald-600 bg-emerald-50 px-2 py-1 rounded-md">
                      Aktif
                    </span>
                  </div>

                  <h3 className="font-heading text-xl font-semibold text-slate-900 mb-2">
                    {tool.title}
                  </h3>
                  <p className="text-sm text-slate-500 leading-relaxed flex-1">
                    {tool.description}
                  </p>

                  <div className="mt-6 pt-5 border-t border-slate-100">
                    <Link to={tool.path}>
                      <Button
                        className="w-full bg-slate-900 hover:bg-blue-600 text-white font-medium h-10 group/btn"
                        data-testid={`tool-card-${tool.id}-button`}
                      >
                        Aracı Aç
                        <ArrowRight className="w-4 h-4 ml-2 group-hover/btn:translate-x-0.5 transition-transform" />
                      </Button>
                    </Link>
                  </div>
                </CardContent>
              </Card>
            );
          })}

          {/* Yer tutucu kartlar (yakında) */}
          <Card className="border-dashed border-slate-300 bg-transparent shadow-none">
            <CardContent className="p-6 md:p-7 flex flex-col h-full min-h-[260px] items-center justify-center text-center">
              <div className="w-12 h-12 rounded-xl bg-slate-100 text-slate-400 flex items-center justify-center mb-4">
                <Wrench className="w-6 h-6" />
              </div>
              <h3 className="font-heading text-base font-semibold text-slate-700 mb-1">
                Yeni araçlar yolda
              </h3>
              <p className="text-xs text-slate-400 max-w-[200px]">
                Bu alana yeni firma araçları eklenecek.
              </p>
            </CardContent>
          </Card>
        </section>
      </main>
    </div>
  );
};

export default DashboardPage;
